import { styled } from "styled-components";

export const StyledStudentSelectionInput = styled.div`
  width: 90%;
  @media (min-width: 720px) {
    width: 50%;
  }
`;
